import React, { useState, useEffect } from 'react';
import { FaTimes, FaWhatsapp, FaInstagram, FaFacebookF, FaPhone } from 'react-icons/fa';
import { SiTiktok } from 'react-icons/si';
import styles from './NavBarNew.module.css';
import logo from "../../images/חינת הזהב לוגו.webp";

const NavBarNew = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) setIsVisible(true);
      else setIsVisible(false);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    if (isMenuOpen) {
      setIsClosing(true);
      setTimeout(() => {
        setIsMenuOpen(false);
        setIsClosing(false);
        document.body.style.overflow = 'auto';
      }, 500);
    } else {
      setIsMenuOpen(true);
      document.body.style.overflow = 'hidden';
    }
  };

  const closeMenu = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsMenuOpen(false);
      setIsClosing(false);
      document.body.style.overflow = 'auto';
    }, 500);
  };

  const openWhatsApp = () => {
    const phoneNumber = '972507277178';
    const message = 'היי חינת הזהב, אשמח לקבל עוד פרטים לגבי האירוע שלי';
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
    closeMenu();
  };

  const scrollToSection = (sectionId) => {
    closeMenu();
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        const offset = 100;
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - offset;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }, 600);
  };

  const whatsappLink = "https://wa.me/972507277178?text=היי%20חינת%20הזהב%2C%20הגעתי%20מהדף%20שלכם%21%20אשמח%20לשמוע%20עוד%20על..";
  const instagramLink = "https://www.instagram.com/hinatazav/";
  const tiktokLink = "https://www.tiktok.com/@henatazav";


  return (
    <>
      <nav className={`${styles.navbar} ${isVisible ? styles.visible : styles.hidden}`}>
        <div className={styles.navbarInner}>
          <div className={styles.logo}>
            <img src={logo} alt="לוגו" loading="lazy" />
          </div>
          
          <div className={styles.mainSocialLinks}>
             <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className={styles.socialLink} aria-label="שלחי הודעה בוואטסאפ">
                <div className={styles.iconWrapperSmall}>
                  <FaWhatsapp />
                </div>
              </a>
              <a href={instagramLink} target="_blank" rel="noopener noreferrer" className={styles.socialLink} aria-label="עקבי באינסטגרם">
                <div className={styles.iconWrapperSmall}>
                  <FaInstagram />
                </div>
              </a>
              <a href={tiktokLink} target="_blank" rel="noopener noreferrer" className={styles.socialLink} aria-label="עקבי בטיקטוק">
                <div className={styles.iconWrapperSmall}>
                  <SiTiktok />
                </div>
              </a>
          </div>

          <button className={styles.menuButton} onClick={toggleMenu}>
            <div className={styles.buttonContent}>
              <span className={styles.buttonText}>תפריט</span>
            </div>
          </button>
        </div>
      </nav>

      {isMenuOpen && (
        <div className={`${styles.menuOverlay} ${isClosing ? styles.closing : ''}`} onClick={toggleMenu}>
          <div className={styles.menuModal} onClick={(e) => e.stopPropagation()}>
            <div className={styles.menuHeader}>
              <button className={styles.menuCloseButton} onClick={toggleMenu}>
                <FaTimes />
              </button>
              <div className={styles.menuLogo}>
                <img src={logo} alt="לוגו" loading="lazy" />
              </div>
            </div>
            
            <div className={styles.menuContent}>
              <button 
                className={styles.menuLink} 
                onClick={() => scrollToSection('מי אנחנו')}
              >
                <span>מי אנחנו</span>
              </button>
              
              <button 
                className={styles.menuLink} 
                onClick={() => scrollToSection('מה אומרים עלינו')}
              >
                <span>מה אומרים עלינו</span>
              </button>
              
              <button 
                className={styles.menuLink} 
                onClick={() => scrollToSection('מה תקבלי בחינה')}
              >
                <span>מה תוכלי לקבל בחינה</span>
              </button>
              
              <button 
                className={styles.menuLink} 
                onClick={() => scrollToSection('מפורסמים')}
              >
                <span>מפורסמים בחינת הזהב</span>
              </button>
              
              <button 
                className={`${styles.menuLink} ${styles.contactButton}`} 
                onClick={openWhatsApp}
              >
                <span>ליצירת קשר מיידי איתנו</span>
              </button>

              <div className={styles.socialLinksContainer}>
                <div className={styles.socialGrid}>
                  <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className={styles.socialLink} aria-label="שלחי הודעה בוואטסאפ" onClick={closeMenu}>
                    <div className={styles.iconWrapper}>
                      <FaWhatsapp />
                    </div>
                  </a>
                  <a href="tel:+972507277178" target="_blank" rel="noopener noreferrer" className={styles.socialLink} aria-label="התקשרי עכשיו" onClick={closeMenu}>
                    <div className={styles.iconWrapper}>
                      <FaPhone />
                    </div>
                  </a>
                  <a href={instagramLink} target="_blank" rel="noopener noreferrer" className={styles.socialLink} aria-label="עקבי באינסטגרם" onClick={closeMenu}>
                    <div className={styles.iconWrapper}>
                      <FaInstagram />
                    </div>
                  </a>
                  <a href={tiktokLink} target="_blank" rel="noopener noreferrer" className={styles.socialLink} aria-label="עקבי בטיקטוק" onClick={closeMenu}>
                    <div className={styles.iconWrapper}>
                      <SiTiktok />
                    </div>
                  </a>
                  <a href="https://www.facebook.com/henatazav" target="_blank" rel="noopener noreferrer" className={styles.socialLink} aria-label="עקבי בפייסבוק" onClick={closeMenu}>
                    <div className={styles.iconWrapper}>
                      <FaFacebookF />
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NavBarNew;